import { EstadoServidor } from "../../bussines/entities/EstadoServidor.entity";

export class EstadoServidorModel implements EstadoServidor {
    constructor(
        public ip: string,
        public servidor: string,
        public estado: string,
        public tiempo: string,
        public revisadoEn: string,
        public mensaje?: string
    ) { }

    serialize(): EstadoServidor {
        return {
            ip: this.ip,
            servidor: this.servidor,
            estado: this.estado,
            tiempo: this.tiempo,
            revisadoEn: this.revisadoEn,
            mensaje: this.mensaje
        };
    }

    static deserialize(entity: EstadoServidor): EstadoServidorModel{
        return new EstadoServidorModel(
            entity.ip ?? '',
            entity.servidor ?? '',
            entity.estado ?? '',
            entity.tiempo ?? '',
            entity.revisadoEn ?? '',
            entity.mensaje ?? ''
        );
    }

}